import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function SkillsPage() {
  const detailedSkills = [
    {
      domain: 'Langages',
      technologies: ['JavaScript', 'TypeScript', 'Python', 'PHP', 'Java', 'C/C++', 'C#', 'HTML5', 'CSS3', 'SCSS', 'SQL', 'Bash', 'Dart']
    },
    {
      domain: 'Frameworks Frontend',
      technologies: ['React.js', 'Vue.js', 'Angular', 'Next.js', 'Nuxt.js', 'Tailwind CSS', 'Bootstrap', 'DaisyUI']
    },
    {
      domain: 'Frameworks Backend',
      technologies: ['Node.js', 'Express.js', 'Laravel', 'Symfony', 'Flask', 'Spring Boot', 'ASP.NET']
    },
    {
      domain: 'Mobile',
      technologies: ['Flutter', 'Dart', 'Material UI', 'Cupertino', 'Provider', 'Riverpod', 'Bloc']
    },
    {
      domain: 'Bases de Données',
      technologies: ['MySQL', 'PostgreSQL', 'MongoDB', 'SQLite', 'Redis', 'Firebase']
    },
    {
      domain: 'API & Web',
      technologies: ['REST API', 'GraphQL', 'Socket.io', 'JWT', 'Swagger']
    },
    {
      domain: 'DevOps',
      technologies: ['Git', 'Docker', 'Kubernetes', 'Jenkins', 'GitLab CI/CD', 'GitHub Actions', 'Nginx']
    },
    {
      domain: 'Méthodologies',
      technologies: ['Agile', 'Scrum', 'Kanban', 'MVC', 'MVVM', 'Clean Architecture', 'SOLID', 'Design Patterns']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <h1 className="text-7xl font-black text-[#0A0A0A] leading-tight mb-6">
              Compétences<br />Techniques<br />Détaillées
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl">
              Vue d'ensemble complète de toutes mes compétences techniques organisées par domaine d'expertise.
            </p>
          </div>

          <div className="bg-[#FAFAF8] rounded-3xl p-8 shadow-lg">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b-2 border-gray-300">
                    <th className="text-left py-4 px-6 text-lg font-bold text-[#0A0A0A] w-1/4">
                      Domaine
                    </th>
                    <th className="text-left py-4 px-6 text-lg font-bold text-[#0A0A0A]">
                      Technologies
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {detailedSkills.map((skill, index) => (
                    <tr 
                      key={index}
                      className="border-b border-gray-200 hover:bg-white transition-colors duration-200"
                    >
                      <td className="py-5 px-6 font-semibold text-[#0A0A0A] align-top">
                        {skill.domain}
                      </td>
                      <td className="py-5 px-6">
                        <div className="flex flex-wrap gap-2">
                          {skill.technologies.map((tech, idx) => (
                            <span
                              key={idx}
                              className="bg-white text-gray-700 px-4 py-2 rounded-full text-sm font-medium border border-gray-200 hover:border-[#0066FF] hover:text-[#0066FF] transition-all duration-200 cursor-pointer whitespace-nowrap"
                            >
                              {tech}
                            </span>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-16 text-center">
            <Link 
              to="/#contact" 
              className="inline-flex items-center px-8 py-4 bg-[#0066FF] text-white rounded-full font-semibold hover:bg-[#0052CC] transition-all duration-300 hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Discutons de votre projet
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
